module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }